import {
  memberAPI,
  publicAPI
} from '../request';
import { findDomain, adaptUrl } from '@/utils/url';
export default {
  getActivitiesFromPublicApi: (zoneId) => {
    const url = adaptUrl(':domain/activities', {
      params: {
        domain: findDomain()
      },
      queries: {
        zoneId
      }
    });
    return publicAPI.get(url);
  },
  getActivitiesFromMembersApi: (zoneId) => {
    const url = adaptUrl('activities', {
      queries: {
        zoneId
      }
    });
    return memberAPI.get(url);
  }
};
